import { createFileRoute } from "@tanstack/react-router";
import { site } from "@/data/site";
import { Section } from "@/components/site/Section";
import { meta } from "@/lib/schema";

const title = "Algemene voorwaarden | Vakkundig Verhuizingen & Transport";
const description =
  "De algemene voorwaarden van Vakkundig Verhuizingen & Transport: offertes, uitvoering, aansprakelijkheid, betaling en annulering.";

export const Route = createFileRoute("/algemene-voorwaarden")({
  head: () => meta({ title, description, path: "/algemene-voorwaarden" }),
  component: TermsPage,
});


const sections = [
  {
    heading: "1. Toepasselijkheid",
    text: `Deze voorwaarden gelden voor alle offertes, opdrachten en werkzaamheden van ${site.name} (KvK ${site.kvk}), gevestigd aan ${site.address.street}, ${site.address.postalCode} ${site.address.city}. Afwijkende afspraken gelden alleen als wij die schriftelijk hebben bevestigd.`,
  },
  {
    heading: "2. Offerte en overeenkomst",
    text: "Onze offerte is 30 dagen geldig en is gebaseerd op de informatie die de opdrachtgever aanlevert. Wijkt de werkelijke situatie hiervan af (meer inboedel, geen parkeergelegenheid, extra verdiepingen, langere loopafstand), dan kunnen de kosten worden aangepast. De overeenkomst komt tot stand zodra de opdrachtgever de offerte schriftelijk of per e-mail accepteert.",
  },
  {
    heading: "3. Uitvoering van de werkzaamheden",
    text: "Wij voeren de verhuizing of het transport uit als een zorgvuldig vakbedrijf. De opdrachtgever zorgt ervoor dat de woning of bedrijfsruimte toegankelijk is, dat er geparkeerd kan worden en dat eventuele ontheffingen zijn geregeld, tenzij wij dit in de offerte hebben opgenomen. Genoemde tijden zijn indicatief; bij verkeer, weersomstandigheden of onvoorziene situaties kan de planning schuiven.",
  },
  {
    heading: "4. Verpakken en aansprakelijkheid",
    text: "Zaken die door de opdrachtgever zelf zijn ingepakt, worden vervoerd zonder dat wij de inhoud kunnen controleren; schade aan de inhoud van zelf ingepakte dozen valt niet onder onze aansprakelijkheid. Wij vervoeren verzekerd conform onze transportverzekering. Onze aansprakelijkheid is beperkt tot het bedrag dat de verzekeraar in het betreffende geval uitkeert. Schade dient uiterlijk binnen twee werkdagen na de verhuizing schriftelijk gemeld te worden, met foto's.",
  },
  {
    heading: "5. Uitgesloten zaken",
    text: "Wij vervoeren geen geld, sieraden, waardepapieren, levende dieren, planten met wortelkluit, brandbare of gevaarlijke stoffen en zaken van uitzonderlijke waarde, tenzij hierover uitdrukkelijk aparte afspraken zijn gemaakt.",
  },
  {
    heading: "6. Betaling",
    text: "Betaling gebeurt zoals in de offerte is aangegeven: vooraf, direct na afronding van de werkzaamheden of binnen 14 dagen na factuurdatum. Bij te late betaling zijn wij bevoegd wettelijke rente en redelijke invorderingskosten in rekening te brengen.",
  },
  {
    heading: "7. Annuleren en verplaatsen",
    text: "Annuleren of verplaatsen kan kosteloos tot 5 werkdagen voor de afgesproken datum. Bij annulering binnen 5 werkdagen brengen wij 25% van het offertebedrag in rekening, binnen 48 uur 50%. Verplaatsen in overleg is altijd mogelijk zolang er ruimte in de planning is.",
  },
  {
    heading: "8. Opslag",
    text: "Voor tijdelijke opslag geldt een overeengekomen periode en tarief per maand of gedeelte daarvan. Zolang openstaande bedragen niet zijn betaald, kunnen wij de opgeslagen zaken onder ons houden. Wij bewaren de zaken droog, afgesloten en verzekerd.",
  },
  {
    heading: "9. Klachten",
    text: `Heb je een klacht over onze dienstverlening? Neem dan zo snel mogelijk contact op via ${site.email} of ${site.phone}. Wij reageren binnen 5 werkdagen en zoeken samen naar een passende oplossing.`,
  },
  {
    heading: "10. Toepasselijk recht",
    text: "Op onze overeenkomsten is Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter in het arrondissement Den Haag.",
  },
];

function TermsPage() {
  return (
    <Section>
      <div className="mx-auto max-w-3xl">
        <h1 className="font-display text-3xl font-extrabold text-secondary sm:text-4xl">
          Algemene voorwaarden
        </h1>
        <p className="mt-3 text-muted-foreground">
          Deze voorwaarden gelden voor alle verhuizingen, transporten, ontruimingen en opslag die wij
          uitvoeren. Heb je hier een vraag over? Neem gerust contact met ons op.
        </p>
        <div className="mt-10 space-y-8">
          {sections.map((section) => (
            <article key={section.heading}>
              <h2 className="font-display text-xl font-bold text-secondary">{section.heading}</h2>
              <p className="mt-2 leading-relaxed text-muted-foreground">{section.text}</p>
            </article>
          ))}
        </div>
      </div>
    </Section>
  );
}
